import * as STD                            from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import { Block } from '@emersya/mpa-components';
import { NS as ProductFloorEditor } from '../floor/Editor/PlannerFloorEditor';
import { NS as ProductWallEditor } from '../walls/Editor/PlannerWallsEditor';

export interface IPlannerFloorWallsComponentConfiguration extends Block.Configuration {
	wall : STD.translationsManager.TranslationMapping;
	backWall : STD.translationsManager.TranslationMapping;
	leftWall : STD.translationsManager.TranslationMapping;
	rightWall : STD.translationsManager.TranslationMapping;
	label : STD.translationsManager.TranslationMapping;
	nameFloor : STD.translationsManager.TranslationMapping;
	nameWall : STD.translationsManager.TranslationMapping;
	allFree : boolean;
	labelFloor : STD.translationsManager.TranslationMapping | null;
};

export class PlannerFloorWallsComponent extends Block.Component {
	static override initialize() {
		super.initialize();
	};

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('',{});
		}
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IPlannerFloorWallsComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			floorMenu : <ProductFloorEditor.Configuration>{
				'@translations' : {
					name : configuration.nameFloor
				},
				label : configuration.labelFloor,
				allFree : configuration.allFree
			},
			wallsMenu : <ProductWallEditor.Configuration>{
				'@translations' : {
					name: configuration.nameWall,
					back: configuration.backWall,
					right: configuration.rightWall,
					left: configuration.leftWall,
					label: configuration.label,
					wall: configuration.wall
				},
				allFree : configuration.allFree
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory();

	};
};
export namespace NS {
	export const Component = PlannerFloorWallsComponent;
	export type Component = PlannerFloorWallsComponent;
	export type Configuration = IPlannerFloorWallsComponentConfiguration;
}
import manifestXMLSource                   from './Floor-Walls.xml';
import './Floor-Walls.scss';

CM.Manager.declare({
	id :       'viewer-planner-floor-walls',
	type :     PlannerFloorWallsComponent,
	manifest : manifestXMLSource
});
